import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import {
	get_user_profile,
	update_user_profile,
} from '../../redux/actions/userAuthActions'
// import {
// 	UPDATE_USER_PROFILE_RESET,
// 	GET_USER_PROFILE_RESET,
// } from '../../redux/types'
import Loader from '../../components/Loader'
import countryList from 'react-select-country-list'
import { DatePicker } from 'react-rainbow-components'
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector'

const UserDashboardProfile = () => {
	const dispatch = useDispatch()

	const [firstName, setFirstName] = useState('')
	const [lastName, setLastName] = useState('')
	const [description, setDescription] = useState('')
	const [gender, setGender] = useState('')
	const [language, setLanguage] = useState('')
	const [skills, setSkills] = useState([])
	const [email, setEmail] = useState('')
	const [phoneNumber, setPhoneNumber] = useState('')
	const [dob, setDob] = useState(null)
	const [nationalityArray, setNationalityArray] = useState({})
	const [nationality, setNationality] = useState('')
	const [country, setCountry] = useState('')
	const [location, setLocation] = useState('')

	const [mainImage, setMainImage] = useState(null)
	const [uploadedImage, setUploadedImage] = useState('')
	const [uploading, setUploading] = useState(false)

	const options = useMemo(() => countryList().getData(), [])

	const getUserProfile = useSelector((state) => state.getUserProfile)
	const { loading, userProfile } = getUserProfile

	const userUpdateProfile = useSelector((state) => state.userUpdateProfile)
	const { loading: loadingUpdate, success } = userUpdateProfile

	const userAuth = useSelector((state) => state.userAuth)
	const { userDetail } = userAuth

	const changeHandler = (nationalityArray) => {
		setNationalityArray(nationalityArray)

		setNationality(nationalityArray.label)
		console.log(nationality)
	}

	function onDateChange(dob) {
		setDob(dob)
	}

	function selectCountry(country) {
		setCountry(country)
	}

	function selectRegion(location) {
		setLocation(location)
	}

	const getBase64 = (file) => {
		return new Promise((resolve) => {
			let baseURL = ''
			let reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => {
				// Make a fileInfo Object
				baseURL = reader.result
				resolve(baseURL)
			}
		})
	}

	const handleFileInputChange = async (e) => {
		let file = e.target.files[0]
		setMainImage(file)
		getBase64(file)
			.then((result) => {
				file['base64'] = result
				console.log('File Is', file)
				// let split = file.base64.split(',');
				// setImageFile(split[1]);
				// let type = file.type.split('/');
				// setImageFormat(type[1]);
			})
			.catch((err) => {
				console.log(err)
			})

		await uploadFileHandler(file)
	}

	const uploadFileHandler = (mainImage) => {
		const formData = new FormData()
		formData.append('file', mainImage)
		formData.append('image', mainImage)
		formData.append('upload_preset', 'feemfundy')
		formData.append('cloud_name', 'neutrinookoye')

		setUploading(true)

		fetch('https://api.cloudinary.com/v1_1/neutrinookoye/image/upload', {
			method: 'POST',
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				setUploading(false)
				setMainImage(null)
				setUploadedImage(data.url)
				// setImageFile('')
			})
			.catch((err) => {
				console.log(err)
				setUploading(false)
				setMainImage(null)
				// setImageFile('')
			})
	}

	const submitHandler = (e) => {
		e.preventDefault()
		let data = {
			firstName,
			lastName,
			description,
			gender,
			language,
			skills,
			dob,
			nationality,
			country,
			state: location,
			profileImage: uploadedImage,
			phoneNumber,
		}
		dispatch(update_user_profile(userDetail.fullName, data))
	}

	useEffect(() => {
		if (!userProfile || userDetail.id != userProfile.id) {
			dispatch(get_user_profile(userDetail.fullName))
		} else {
			setFirstName(userProfile.firstName)
			setLastName(userProfile.lastName)
			setEmail(userProfile.email)
			setPhoneNumber(userProfile.phoneNumber)
			setDescription(userProfile.description)
			setGender(userProfile.gender)
			setLanguage(userProfile.language)
			setSkills(userProfile.skills)
			setDob(userProfile.dob)
			setNationality(userProfile.nationality)
			setCountry(userProfile.country)
			setLocation(userProfile.state)
		}
	}, [dispatch, userDetail, userProfile.id, success])

	return (
		<>
			<section className='user_dashboard'>
				{loading ? (
					<Loader />
				) : userProfile ? (
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-10'>
								<div className='user_dashboard_profile_form'>
									<form onSubmit={submitHandler}>
										<div className='row'>
											<div className='col-md-6'>
												<label> First Name </label>
												<input
													type='text'
													className='form-control'
													value={firstName}
													onChange={(e) => setFirstName(e.target.value)}
												/>
											</div>
											<div className='col-md-6'>
												<label> Last Name </label>
												<input
													type='text'
													className='form-control'
													value={lastName}
													onChange={(e) => setLastName(e.target.value)}
												/>
											</div>
											<div className='col-md-6'>
												<label> Email </label>
												<input
													type='email'
													className='form-control'
													value={userProfile.email}
													disabled
													onChange={(e) => setEmail(e.target.value)}
												/>
											</div>
											<div className='col-md-6'>
												<label> Phone Number </label>
												<input
													type='text'
													className='form-control'
													value={phoneNumber}
													onChange={(e) => setPhoneNumber(e.target.value)}
												/>
											</div>
											<div className='col-md-12'>
												<label> Describe yourself </label>
												<textarea
													id=''
													cols='30'
													rows='5'
													className='form-control'
													onChange={(e) => setDescription(e.target.value)}
													value={description}
												></textarea>
											</div>
											<div className='col-md-6 mb-4'>
												<label> Nationality: {userProfile.nationality} </label>
												<Select
													options={options}
													value={nationalityArray}
													onChange={changeHandler}
												/>
											</div>
											<div className='col-md-6'>
												<label> Date of Birth </label>
												<DatePicker
													id='datePicker-1'
													value={dob}
													onChange={onDateChange}
													label=''
													formatStyle='large'
												/>
											</div>
											<div className='col-md-12'>
												<div className='row'>
													<div className='col-md-6'>
														<label> Country of Residence</label>
														<CountryDropdown
															value={country}
															onChange={(val) => selectCountry(val)}
															classes='form-control'
														/>
													</div>
													<div className='col-md-6'>
														<label> State </label>
														<RegionDropdown
															country={country}
															value={location}
															onChange={(val) => selectRegion(val)}
															classes='form-control'
														/>
													</div>
												</div>
											</div>
											<div className='col-md-6'>
												<label> Language </label>
												<input
													type='text'
													value={language}
													className='form-control'
													onChange={(e) => setLanguage(e.target.value)}
												/>
											</div>
											<div
												className='col-md-6'
												style={{ position: 'relative' }}
											>
												<label> Gender </label>
												<br />
												<input
													type='radio'
													name='gender'
													value='male'
													defaultChecked={
														`${userProfile.gender}` === 'male' ? true : false
													}
													id=''
													onChange={(e) => setGender(e.target.value)}
													className='radio'
												/>{' '}
												<span className='mr-5 male'>Male</span>
												<input
													type='radio'
													name='gender'
													value='female'
													defaultChecked={
														`${userProfile.gender}` === 'female' ? true : false
													}
													id=''
													onChange={(e) => setGender(e.target.value)}
													className='radio'
												/>{' '}
												<span className='female'>Female</span>
											</div>
											<div className='col-md-6'>
												<label> Skills </label>
												<select
													name=''
													id=''
													className='form-select'
													onChange={(e) => setSkills(e.target.value)}
												>
													<option value=''></option>
												</select>
											</div>
											<div className='col-md-6'>
												<label> Profile Picture </label>
												<input
													type='file'
													id=''
													onChange={handleFileInputChange}
												/>
												{uploading && <i className='fas fa-spinner'></i>}
											</div>
										</div>
										<div className='text-right'>
											<button
												type='submit'
												disabled={
													loadingUpdate ? true : uploading ? true : false
												}
												className='btn btn-danger'
											>
												Update
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				) : (
					'No data to display'
				)}
			</section>
		</>
	)
}

export default UserDashboardProfile
